import RNFS from "react-native-fs"
export default RNFS
